import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "가이드",
  "description": "Turborepo에서 좋아하는 도구를 사용하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 좋아하는 프레임워크, CI 제공업체, 도구 및 사용 사례와 함께 작동합니다."
  }, {
    "heading": "",
    "content": "커뮤니티에서 지원하는 가이드에서 turbo를 나머지 도구와 함께 사용하는 방법의 예를 찾을 수 있습니다."
  }],
  "headings": []
};
import {Cards, Card} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo는 좋아하는 프레임워크, CI 제공업체, 도구 및 사용 사례와 함께 작동합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["커뮤니티에서 지원하는 가이드에서 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 나머지 도구와 함께 사용하는 방법의 예를 찾을 수 있습니다."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "프레임워크",
        description: "Turborepo에 프레임워크를 통합합니다",
        href: "/docs/guides/frameworks"
      }), _jsx(Card, {
        title: "지속적 통합",
        description: "CI와 함께 Turborepo를 사용합니다",
        href: "/docs/guides/ci-vendors"
      }), _jsx(Card, {
        title: "도구",
        description: "좋아하는 도구를 가져옵니다",
        href: "/docs/guides/tools"
      }), _jsx(Card, {
        title: "단일 패키지 워크스페이스",
        description: "독립 실행형 애플리케이션과 통합합니다",
        href: "/docs/guides/single-package-workspaces"
      }), _jsx(Card, {
        title: "코드 생성",
        description: "새 코드를 빠르게 생성합니다",
        href: "/docs/guides/generating-code"
      }), _jsx(Card, {
        title: "작업 건너뛰기",
        description: "아무것도 하지 않아 빠르게 진행합니다",
        href: "/docs/guides/skipping-tasks"
      }), _jsx(Card, {
        title: "패키지 게시",
        description: "Turborepo 외부에서 패키지를 사용합니다",
        href: "/docs/guides/publishing-libraries"
      }), _jsx(Card, {
        title: "플랫폼 처리",
        description: "OS, Node.js 버전 및 기타 요인",
        href: "/docs/guides/handling-platforms"
      }), _jsx(Card, {
        title: "다중 언어 지원",
        description: "여러 언어, 하나의 리포지토리",
        href: "/docs/guides/multi-language"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
